import { useTranslation } from 'react-i18next';

import { MediaOverlay } from '../link/MediaOverlay';
import type { ResultSession } from '../results/sessions';
import { useResultSessionStore } from '../results/store';
import { ExamStudentSheet } from './ExamStudentSheet';
import { useExamResultsView } from './useExamResults';

export interface ExamSheetOverlayProps {
  session: ResultSession;
  onBackToDe: () => void;
}

// A student's graded attempt in place of the đề, with prev/next across the class
export function ExamSheetOverlay({ session, onBackToDe }: ExamSheetOverlayProps) {
  const { order, names, questions } = useExamResultsView(session.refId);
  const { t } = useTranslation('exams');
  const openStudent = useResultSessionStore((state) => state.openStudent);
  const index = order.map((attempt) => attempt.code).indexOf(session.student || '');
  if (index < 0) return null;
  const attempt = order[index];
  return (
    <MediaOverlay title={t('sheet.title', { name: names[attempt.code] || attempt.name })} fit="fill" onClose={onBackToDe}>
      <div className="exam-sheet-surface">
        <ExamStudentSheet order={order} index={index} names={names} questions={questions} onStep={(next) => { if (order[next]) openStudent(session.tabId, order[next].code); }} onBack={onBackToDe} />
      </div>
    </MediaOverlay>
  );
}
